import sha256 from 'crypto-js/sha256';
import { env } from '@shared/config/env';

export async function hashPassword(password: string): Promise<string> {
  const hashedPassword = sha256(`${password}${env.appSalt}`).toString();
  return hashedPassword;
}

export function generateRandomUserId(prefix = 'CRK'): string {
  const random = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${random}`;
}

export const encryptionKey = env.encryptionKey;
const encode = (str: string) => new TextEncoder().encode(str);
const rawKey = encode(encryptionKey);

const fromBase64Url = (base64url: string) => {
  const base64 = base64url
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(base64url.length + ((4 - (base64url.length % 4)) % 4), '=');
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
};

const decode = (buf: BufferSource) => new TextDecoder().decode(buf as ArrayBuffer);

export async function decrypt(encryptedBase64: string,url='') {
  const data = fromBase64Url(encryptedBase64);

  const nonce = data.slice(0, 12); // first 12 bytes = nonce
  const ciphertext = data.slice(12);

  const newRawKey = url.includes('getAllActiveApps')? encode(env.encryptionKeyOld as string) : rawKey;

  const key = await crypto.subtle.importKey(
    'raw',
    newRawKey,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  );
  try {
    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv: nonce },
      key,
      ciphertext
    );
    return JSON.parse(decode(decrypted));
  } catch (err) {
    console.error('Decryption failed:', err);
    throw err;
  }
}
